import { createSlice } from '@reduxjs/toolkit';
import { revertAll } from '../../store';

const initialState: { showMessage: boolean; messageText: string | null } = {
  showMessage: false,
  messageText: null,
};
export const showPlanUpgradingMessage = createSlice({
  name: 'showPlanUpgradingMessage',
  initialState,
  reducers: {
    showMessage: (state, payload) => {
      state.showMessage = true;
      state.messageText = payload.payload;
    },
    hideMessage: (state) => {
      state.showMessage = false;
      state.messageText = null;
    },
  },
  extraReducers(builder) {
    builder.addCase(revertAll, () => initialState);
  },
});

export default showPlanUpgradingMessage.reducer;
export const { showMessage, hideMessage } = showPlanUpgradingMessage.actions;
